export default __webpack_public_path__ + "static/media/Labirynth-07.309dcc2d.svg";